export default {
  fontFamily: ['Motiva Sans', 'Verdana', 'sans-serif'].join(',')
};
